import { Component, ViewChild, Input, Renderer2, ChangeDetectorRef, ElementRef } from '@angular/core';
import * as _ from 'lodash';
import { ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from '../models/BaseBus';
import { GlobalsService } from '../services/globals.service';
import { MessageType } from '../enums/MessageType';
import { DateFunctions } from '../static/date-functions';
import { BaseService } from '../services/base.service';
import { SaveMode } from '../enums/SaveMode';
import { BaseGridEditLineComponent } from './base-grid-editline.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { GridEditModes } from '../static/CommonValues';
import { EmptyOverridable, validateOverridables } from '../decorators/overridable/base-method-override-decorator';

@Component({
  selector: '',
  template: ''
})
export class BaseGridEditFormLinesComponent<T extends BaseBus, D, S extends BaseService> extends BaseGridEditLineComponent<T,D,S>  {
    public skipSlice: boolean = false;
    constructor(protected globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        validateOverridables(this, Object.getPrototypeOf(this).constructor.name, BaseGridEditLineComponent);
    }

    @EmptyOverridable()
    public afterSetEdit() { }

    addOnlyRequiredValue: boolean = false;
    @Input() addOnlyRequired: boolean = false;
    _addOnly: boolean = false;
    @Input() set addOnly(value: boolean) {
        if (value) {
            this._addOnly = value;
            if (this.addOnlyRequired) {
                this.addOnlyRequiredValue = true;
            }
            this.addHandler();
        }
    }
    get addOnly(): boolean {
        return this._addOnly;
    }
    protected _notesElemRef: ElementRef;
    @ViewChild('notes') set notesElem(content: ElementRef) {

        if (content) { // initially setter gets called with undefined
            this._notesElemRef = content;
            this.setForm();
        }
    }
    get notes(): string {
        return this._notesElemRef ? this._notesElemRef.nativeElement.value : "";
    }
    set notes(value: string) {
        if (this._notesElemRef) {
            this._notesElemRef.nativeElement.value = value;
        }
    }
    public override cellClickHandler({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked: boolean = false): void {
        if ((this.GridEditMode === GridEditModes.editButton && editClicked === false)
            || !this.canEditRow(dataItem, column)
            || !this.canAddEdit
            || this.readOnly
            || (!CommonFunctions.hasStringValue(column.field) && editClicked === false)
            || this.viewingDocument
            || isEdited
            || (this.editForm && !this.editForm.valid)) {
            return;
        }
        else if (!this.canSave) {
            return;
        }
        this.setEdit(dataItem, column, false, false);
    }
    public override addHandler(): void {
        let date: Date = DateFunctions.getDateNow();
        this.selectedData = this.createNew(null);
        this.selectedData.setNew(this.globals.userId, date, this.globals.companyId, this.globals.personId, this._parentId, this.locationDetail);
        this.afterAddNewData();
        this.setEdit(this.selectedData, null, true, false);
    }
    protected override closeEditor(): void {
        this.isNew = false;
        this.editForm = undefined;
        this.showCpSearchDialog = false;
        if (this.grid && this.grid.pageSize && this.hasGridData) {
            this.grid.data = {
                data: this.gridData.slice(this.grid.skip, this.grid.skip + this.grid.pageSize),
                total: this.gridData.length
            };
        }
        if (this.saveMode == SaveMode.all) {
            this.sendParentMessage(MessageType.changed);
        }
    }
    setSkipSlice(value: boolean) {
        this.skipSlice = true;
    }
    setEdit(dataItem: T, col: ColumnComponent, isNew: boolean, readOnly: boolean = false) {
        this.isNew = isNew;
        this.readOnly = readOnly;
        this.createForm();
        this.selectedData = this.createNew(dataItem);
        this.setForm();
        this.afterSetEdit();
        this.formActive = true;
    }

    get formTitle(): string {
        let title = "Edit ";
        if (this.readOnly) {
            title = "View ";
        }
        else if(this.isNew) {
            title = "Add "
        }
        return title + this.appName;
    }
    formActive: boolean = false;
    hideForm() {
        this.formActive = false;
    }
    cancelForm() {
        this.addOnlyRequiredValue = false;
        this.closeEditor();
        this.hideForm();
        this.close(false);
    }
    saveForm() {
        this.addOnlyRequiredValue = false;
        this.saveCurrent();
        this.hideForm();
        this.close(true);
    }
    get noteSaveButtonText(): string {
        return this.saveMode === SaveMode.individual ? "Save" : "Ok";
    }
    get noteCancelButtonText(): string {
        return "Cancel";
    }
    notesPersonId(dataItem: T = null): any {
        return null;
    }
    get canEditNote(): boolean {
        let can: boolean = false;

        if (this.canEdit && this.selectedData) {
            if (this.notesPersonId(this.selectedData) == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }
    canShowEditButton(dataItem: T) {
        let can: boolean = false;

        if (this.canEdit && dataItem) {
            if (this.notesPersonId(dataItem) == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }
    canDeleteNote(dataItem: T): boolean {
        let can: boolean = false;

        if (this.canEdit && dataItem) {
            if (this.notesPersonId(dataItem) == this.globals.personId || this.rights.EditOthersNotes) {
                can = true;
            }
        }

        return can;
    }

}

